var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('cus-base-table',{ref:"ObdDataTable",attrs:{"url":"/advancer/getObdInfo/","toolbar":_vm.toolbar,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }